import { createFileRoute } from '@tanstack/react-router';
import { WorkspaceNotFound } from '@features/workspace-not-found/WorkspaceNotFound';

export const Route = createFileRoute('/workspace-not-found')({
  validateSearch: (s: Record<string, unknown>): { workspace?: string } => ({
    workspace: typeof s.workspace === 'string' && s.workspace !== '' ? s.workspace : undefined,
  }),
  component: WorkspaceNotFound,
});
